import React, { Component, PropTypes } from 'react'
import Game from '../game/Game'
require('../styles/modules/robot.scss');

class Robot extends Component {
  constructor(props) {
    super(props);
    this.state = { showArrows: true }
  }
  componentDidUpdate(){
    if (!this.state.showArrows){
      this.setState({
        showArrows: true
      })
    }
  }
  normalize(number){
    return Math.round(number/25*this.props.size)
  }
  getContainerStyle() {
    let style = {}
    const { location, size } = this.props
    style.top = (size * location[0] -1 )+'px'
    style.left = (size * location[1] - this.normalize(7))+'px'
    return style
  }

  getTopArrowStyle(){
    let style = {}
    var destination = this.props.destinations.up
    const { location, color, currentColor, size } = this.props
    const { showArrows } = this.state
    if(color === currentColor){
      style.display = 'block'
    }
    if(location[0] === destination[0] || !showArrows){
      style.display = 'none'
    }
    style.width = this.normalize(15) + 'px'
    style.height = (size * (location[0] - destination[0]) - this.normalize(5)) + 'px'
    style.top = -(size * (location[0] - destination[0]) - this.normalize(5)) + 'px'
    style.left = this.normalize(11) +'px'
    style.backgroundColor = this.colorMap(color)
    return style;
  }

  getRightArrowStyle(){
    let style = {}
    var destination = this.props.destinations.right
    const { location, color, currentColor, size } = this.props
    const { showArrows } = this.state
    if(color === currentColor){
      style.display = 'block'
    } 
    if(location[1] === destination[1] || !showArrows){
      style.display = 'none'
    }
    style.width = (size * (destination[1]-location[1]) - this.normalize(5)) + 'px'
    style.height = this.normalize(15) + 'px'
    style.top = this.normalize(5) + 'px'
    style.left = this.normalize(30) + 'px'
    style.backgroundColor = this.colorMap(color)
    return style;
  }

  getLeftArrowStyle(){
    let style = {}
    var destination = this.props.destinations.left
    const { location, color, currentColor, size } = this.props
    const { showArrows } = this.state
    if(color === currentColor){
      style.display = 'block'
    } 
    if(location[1] === destination[1] || !showArrows){
      style.display = 'none'
    }
    style.width = (size * (location[1]-destination[1]) - this.normalize(5)) + 'px'
    style.height = this.normalize(15) + 'px'
    style.top = this.normalize(5) + 'px'
    style.left = (-size * (location[1]-destination[1]) + this.normalize(12)) + 'px'
    style.backgroundColor = this.colorMap(color)
    return style;
  }

  getBottomArrowStyle(){
    let style = {}
    var destination = this.props.destinations.down
    const { location, color, currentColor, size } = this.props
    const { showArrows } = this.state
    if(color === currentColor){
      style.display = 'block'
    } 
    if(location[0] === destination[0] || !showArrows){
      style.display = 'none'
    }
    style.width = this.normalize(15) + 'px'
    style.height = (size * (destination[0] - location[0]) - this.normalize(5)) + 'px'
    style.top = size + 'px'
    style.left = this.normalize(11) + 'px'
    style.backgroundColor = this.colorMap(color)
    return style;
  }

  getRobotStyle(){
    let style = {}
    const { color } = this.props
    style.backgroundColor = this.colorMap(color)
    return style
  }

  clickHandler(e){
    e.preventDefault()
    this.props.selectRobot(this.props.color, this.props.location)
  }

  moveHandler(direction, e){
    e.stopPropagation()
    this.setState({
      showArrows: false
    }, ()=>{
      this.props.moveRobot(this.props.color, direction)
    })
  }

  render() {
    return (
      <div className = 'robot-container' style = { this.getContainerStyle() } onClick = { this.clickHandler.bind(this) }>
        <div className = 'robot' style = { this.getRobotStyle() }>
        </div>
        <div className = 'arrow arrow-up' style = { this.getTopArrowStyle() } onClick = { this.moveHandler.bind(this, 'up') } >
        </div> 
        <div className = 'arrow arrow-down' style = { this.getBottomArrowStyle() } onClick = { this.moveHandler.bind(this, 'down') }>
        </div> 
        <div className = 'arrow arrow-right' style = { this.getRightArrowStyle() } onClick = { this.moveHandler.bind(this, 'right') }>
        </div> 
        <div className = 'arrow arrow-left' style = { this.getLeftArrowStyle() } onClick = { this.moveHandler.bind(this, 'left') }>
        </div> 
      </div>
    )
  }
}

Robot.prototype.colorMap = function(color){
  var map = {
    red: 'red',
    blue: '#5555ff',
    yellow: '#FCFF1F',
    green: 'green',
  } 
  return map[color]
}

Robot.defaultProps = {
  color: 'red'
}

Robot.propTypes = {
  color: PropTypes.string,
  location: PropTypes.array
}

export default Robot



// WEBPACK FOOTER //
// ./components/Robot.js